<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).on('mouseenter', '.productListing .product .product-item', function (e) {

    if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {

        if (window.innerWidth > 767) {
            const product = $(this);

            if (product.attr('data-popup-opened') === "true") return;

            const quickshopDiv = product.find('.card .card-information a[data-quickshop-popup]');
            if (quickshopDiv) {

                const productId = product.attr('data-product-id');
                const productHandle = product.attr('data-product-handle');
                const productJson = product.attr('data-product-json');

                if (!productHandle) return;

                if (productJson) {
                    quickshopDiv.click();
                    product.attr('data-popup-opened', 'true');
                }
                else {
                    fetch(`/products/${productHandle}.js`)
                        .then(res => res.json())
                        .then(result => {
                            const variants = result.variants;
                            const json = JSON.stringify({ id: productId, handle: productHandle, media: undefined, variants: variants});

                            product.attr('data-json-product', json);

                            product.find('.card .swatch-label.is-active').click();

                            quickshopDiv.click();
                            product.attr('data-popup-opened', 'true');
                        })
                        .catch(err => {
                            console.error(`Errore nel recupero del prodotto ${productHandle}:`, err);
                        });
                }
            }
        }
    }
});

$(document).on('mouseleave', '.productListing .product .product-item', function (e) {
    if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {

        if (window.innerWidth > 767) {
            const product = $(this);

            const closeLink = product.find('a.variants-popup-close');
            if (closeLink) {
                closeLink.click();
                product.attr('data-popup-opened', 'false')
            }
        }
    }
});

$(document).on('click', '.swatch-element.custom', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const swatch = $(this);
    const swatchProductId = swatch.data('product-id');
    const product = swatch.closest('.product');
    const productWidth = product.width();
    const productItemLength = product.children('.product-item').length;

    product.children('.product-item').each(function (index) {

        const closeLink = product.find('a.variants-popup-close');
        if (closeLink) {
            closeLink.click();
            $(this).attr('data-popup-opened', 'false');
        }


        if (swatchProductId == $(this).data('product-id')) {
            let step = 0;
            if ($(this).position().left > product.position().left) {
                step = (productWidth * index) + (15 * index);
            } else {
                step = -(productWidth * index) - (15 * index);
            }

            product.addClass('no-pointer');

            // Fade out product container
            product.animate({ opacity: 0.1 }, 200, function () {
                // Scroll once fade out is done
                product.animate({ scrollLeft: step }, 600, 'swing', function () {
                    // Fade in product container after scroll completes
                    product.animate({ opacity: 1 }, 200);
                    product.removeClass('no-pointer');
                });
            });
        }
    });
});


document.addEventListener('DOMContentLoaded', async () => {



    $(document).on('click', '.template-store-locator .dropdown .selected, .template-product .dropdown .selected', function () {
        $('.dropdown').removeClass('open');
        $(this).closest('.dropdown').addClass('open');
    });

    $(document).on('click', '.template-store-locator .dropdown ul li', function () {
        //COUNTRY
        if($(this).closest('.dropdown').hasClass('countries')) {
            $('.dropdown.states').removeClass('disabled');
            $('.dropdown.states ul li, .dropdown.stores ul li, .store').hide();
            $('.dropdown.stores').addClass('disabled');
            $('.dropdown.states .selected').html('Provincia');
            $('.dropdown.stores .selected').html('Store');
            var country = $(this).data('country');
            $('.dropdown.states ul li[data-country="'+country+'"]').show();
        }
        //STATE
        if($(this).closest('.dropdown').hasClass('states')) {
            $('.dropdown.stores').removeClass('disabled');
            $('.dropdown.stores ul li, .store').hide();
            $('.dropdown.stores .selected').html('Store');
            var state = $(this).data('state');
            $('.dropdown.stores ul li[data-state="'+state+'"]').show();
        }
        if($(this).closest('.dropdown').hasClass('stores')) {
            var country = $(this).data('country');
            var state = $(this).data('state');
            var address = $(this).data('address');
            var cross_street = $(this).data('cross_street');
            var postal_code = $(this).data('postal_code');
            var city = $(this).data('city');
            var phone_formatted = $(this).data('phone_formatted');
            console.log(address);
            $('.store').hide();
            $('.store li:nth-child(1)').html(address);
            $('.store li:nth-child(2)').html(cross_street+' '+postal_code+' '+city+' ('+state+') - Tel: '+phone_formatted);
            $('.store li:nth-child(3)').html(city+', '+country);
            $('.store').fadeIn();
        }
        $(this).closest('.dropdown').find('.selected').html($(this).html());
        $(this).closest('.dropdown').toggleClass('open');
    });

    if (document.body.classList.contains('template-product')) {
        $(document).ready(function () {
            var barcode = $('.product-option .product-form__input:not(.product-form__swatch) input:checked').data('barcode');
            var size = $('.product-option .product-form__input:not(.product-form__swatch) input:checked').val();
            $('.template-product #tab-disponibilita-in-store .avaibility').attr('data-barcode', barcode);
            $('.template-product #tab-disponibilita-in-store .avaibility').attr('data-size', size);
        });
    }
    $(document).on('click', '.product-option label', function (){
        var barcode = $(this).data('barcode');
        var size = $(this).find('span').html();
        $('.template-product #tab-disponibilita-in-store .avaibility').attr('data-barcode', barcode);
        $('.template-product #tab-disponibilita-in-store .avaibility').attr('data-size', size);
    });

    $(document).on('click', '#tab-disponibilita-in-store .pdViewTab-close, .background-cursor-wrapper', function () {
        $('#tab-disponibilita-in-store .dropdown').find('.selected').html('Regione');
        $('.template-product #tab-disponibilita-in-store .avaibility').html('');
    })

    $(document).on('click', '.template-product .dropdown ul li', function () {
        $('.template-product #tab-disponibilita-in-store .avaibility').html('');
        var region = $(this).attr('data-value');
        var barcode = $('.template-product #tab-disponibilita-in-store .avaibility').attr('data-barcode');
        var size = $('.template-product #tab-disponibilita-in-store .avaibility').attr('data-size');

        if (region != undefined) {
            var url_region = window.location.origin+'/apps/siacloud-1/stores_get/by_region_description/'+region;

            $('.template-product #tab-disponibilita-in-store .avaibility').html('');

            var regionFetch = fetch(url_region)
                .then(response => response.json())
                .then(dataRegion => {
                    for (const [key, value] of Object.entries(dataRegion.data)) {
                        store = `${value.id}`;

                        var avaibilityFetch = fetch(window.location.origin + '/apps/siacloud-1/stock_get_availability_single/' + barcode + "/" + store)
                            .then(response => response.json())
                            .then(dataAvaibility => {
                                if(dataAvaibility.data[barcode]) {
                                    console.log(dataAvaibility.data[barcode]);
                                    if(dataAvaibility.data[barcode].total > 0) {
                                        title = `${value.descrizione_lite}`;
                                        magazzino_dettaglio = `${value.magazzino_dettaglio}`;
                                        data_chiusura = `${value.data_chiusura}`;
                                        if(title != "ECOM - Ecommerce" && magazzino_dettaglio == "S" && data_chiusura == "") {
                                            $('.template-product #tab-disponibilita-in-store .avaibility').append('<li><b>'+`${value.denominazione_estesa}`+ '</b><br>'+`${value.indirizzo}`+ ' - '+`${value.provincia_codice}`+ ' ('+`${value.cap}`+ ') <br> '+`${value.localita}`+' - '+`${value.regione_descrizione}`+'<br><br><span class="size">'+size+'</span><span class="limited-availability">Disponibilità limitata</span></li>');
                                        }
                                    }
                                }
                            });
                    }
                });

            setTimeout(function (){
                if($('.template-product #tab-disponibilita-in-store .avaibility li').length == 0){
                    $('.template-product #tab-disponibilita-in-store .avaibility').append('<li><span class="size">'+size+'</span><span class="ended-availability">Disponibilità terminata</span></li>');
                }
            }, 2000);
        }
        $(this).closest('.dropdown').find('.selected').html($(this).html());
        $(this).closest('.dropdown').toggleClass('open');
    });


    if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
        const container = document.querySelector('.collection-sub-list');
        let isDown = false;
        let startX;
        let scrollLeft;

        if (container) {
            container.addEventListener('mouseenter', () => {
                container.style.cursor = 'grab';
            });

            container.addEventListener('mousedown', (e) => {
                isDown = true;
                container.classList.add('active');
                container.style.cursor = 'grabbing';
                startX = e.pageX - container.offsetLeft;
                scrollLeft = container.scrollLeft;
            });

            container.addEventListener('mouseleave', () => {
                isDown = false;
                container.style.cursor = 'grab';
            });

            container.addEventListener('mouseup', () => {
                isDown = false;
                container.style.cursor = 'grab';
            });

            container.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - container.offsetLeft;
                const walk = (x - startX) * 1.5; // velocità di trascinamento
                container.scrollLeft = scrollLeft - walk;
            });
        }
    }

    $(document).on('click', '#halo-sidebar #CollectionFiltersForm .sidebarBlock.Sort', function (e) {
        e.preventDefault();
        $('.filter-sortby div[data-toggle="dropdown"]').click();
    });

    if (document.body.classList.contains('template-product')) {
        const pageWidth = window.innerWidth || document.documentElement.clientWidth;
        if (pageWidth < 768) {
            const slider = document.querySelector('.template-product .halo-productView-left');
            const padding = slider.offsetHeight;
            const info = document.querySelector('.template-product .productView-top');
            info.style.paddingTop = padding+'px';
        }
    }

    $(document).on('click', 'footer .halo-row .footer-block__item:nth-child(4) ul li:nth-child(4) a', function (e) {
        e.preventDefault();
        $('#shopify-pc__banner__btn-manage-prefs').click();
    });

    $(document).on('click', '.footer.footer-2 .footer-block__item:nth-child(4) ul li:nth-child(4)', function () {



        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const preview_privacy_banner = urlParams.get('preview_privacy_banner');

        if (preview_privacy_banner == null) {
            var href = $(this).find('a').attr('href');
            window.location = href;
        }


    });

});

document.querySelectorAll('.halo-top-country').forEach(select => {
    const selected = select.querySelector('.selected');
    const options = select.querySelector('.options');
    const optionItems = options.querySelectorAll('li');

    selected.addEventListener('click', () => {
        const isOpen = options.style.display === 'block';
        document.querySelectorAll('.options').forEach(opt => opt.style.display = 'none');
        options.style.display = isOpen ? 'none' : 'block';
    });

    optionItems.forEach(item => {
        item.addEventListener('click', () => {
            selected.textContent = item.textContent;
            options.style.display = 'none';

            setTimeout(() => {
                window.location.href = '?country='+item.dataset.iso;
            }, 200);
        });
    });
});

document.addEventListener('click', (e) => {
    if (!e.target.closest('.halo-top-country')) {
        document.querySelectorAll('.options').forEach(opt => {
            opt.style.display = 'none';
        });
    }
});
